import * as React from 'react';
const ReportTable = (props) => React.createElement("div", { className: props.className }, props.children);
export default ReportTable;
